const TEXT = "La cucina di casa — Pronta da portare con te — Gastronomia calda a Lecce — Ogni giorno qualcosa di buono — ";

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-charred/10 py-5 md:py-7 select-none" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee">
        {[0, 1].map((i) => (
          <span key={i} className="font-serif italic text-2xl md:text-4xl text-terracotta/50 pr-4">
            {TEXT.repeat(2)}
          </span>
        ))}
      </div>
    </div>
  );
}
